import { CSSObject } from '@emotion/react';

export const wrap: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0 16px',
};

export const formBox: CSSObject = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px 0',
};

export const previewBox: CSSObject = {
  width: '320px',
  flexShrink: 0,
};

/** 입력 행들을 감싸 세로 간격을 준다. Box 는 gap 을 갖지 않는다. */
export const fields: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px 0',
};

export const field: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0 16px',
  minHeight: '40px',
};

export const label: CSSObject = {
  width: '96px',
  flexShrink: 0,
  lineHeight: '40px',
  fontSize: '14px',
  fontWeight: 600,
};

export const radios: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  minHeight: '40px',
  gap: '0 24px',
};

export const selectedEvent: CSSObject = {
  fontSize: '13px',
  color: '#5f6069',
};

export const hint: CSSObject = {
  marginTop: '4px',
  fontSize: '12px',
  color: 'gray',
};

export const confirmNote: CSSObject = {
  marginTop: '8px',
  fontSize: '13px',
  color: '#8a8d94',
};

export const buttons: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0 8px',
  marginTop: '8px',
};
